/**
 * Admin panelin ön-yüz yolu — tüm admin route'lar bu sabiti kullanır.
 *
 * Değer, build zamanında `REACT_APP_ADMIN_PATH` env değişkeninden okunur
 * (`frontend/.env`). Varsayılan `/super-admin` — klasik `/admin`'den farklı
 * bir path seçildi (otomatik tarayıcılarda tahmin edilmesin diye).
 *
 * Değiştirilmek istenirse hem `frontend/.env` hem `backend/.env`
 * (`SUPERADMIN_PATH`) birlikte güncellenmelidir — backend tarafında URL
 * oluşturan e-posta / log satırlarının doğru link üretmesi için.
 */
export const ADMIN_PATH =
    process.env.REACT_APP_ADMIN_PATH || "/super-admin";

/** Login formunun yaşadığı yol (admin oturumu yoksa yönlendirilir). */
export const ADMIN_LOGIN_PATH = ADMIN_PATH;

/** Giriş sonrası iniş sayfası. */
export const ADMIN_DASHBOARD_PATH = `${ADMIN_PATH}/overview`;

/** İlk-giriş zorunlu parola değiştirme sayfası. */
export const ADMIN_CHANGE_PW_PATH = `${ADMIN_PATH}/change-password`;
